import { Injectable } from '@angular/core';
import { ShellUriService } from './shell-uri.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Initials } from '../../models/initials.model';
import { Login } from '../../models/Login.model';


@Injectable({
    providedIn: 'root'
})

export class ShellGatewayService {

    constructor(private shellUriService: ShellUriService, private http: HttpClient) { }

    public getShellInitial(): Observable<Initials> {
        const url = this.shellUriService.shellInitialUri();
        return this.http.get<Initials>(url);
    }

    public addUserRefreshToken(refresh: string): Observable<Login> {
        const url = this.shellUriService.userRefreshTokenUri(refresh);
        return this.http.post<Login>(url, refresh);
    }
}



